import React, {ReactNode} from 'react';
import {css} from '@emotion/react'
import {useTheme} from '@mui/material'

interface ErrorToastComponentProps {
	icon: ReactNode
	content: ReactNode
	name?: string // required for queue
}

const cssRoot = css`
	display: flex;
	align-items: center;
	justify-content: center;
`
const cssOne = css`
	flex-grow: 0;
`

export function ToastIconComponent({icon, content}: ErrorToastComponentProps) {
	const theme = useTheme()
	const cssTwo = css`
		flex-grow: 1;
		white-space: pre-line;
		padding: ${theme.spacing(1)};
	`
	return (
		<div css={cssRoot}>
			<div css={cssOne}>
				{icon}
			</div>
			<div css={cssTwo}>
				{content}
			</div>
		</div>
	)
}